import { render } from "./inAppNotifications.vue?vue&type=template&id=0fda7d02&ts=true"
import script from "./inAppNotifications.vue?vue&type=script&lang=ts"
export * from "./inAppNotifications.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\projects\\fpbillions\\app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__